import { useQuery } from '@tanstack/react-query';
import { shippingService } from '../services/shipping.service';

export function useShippingRates() {
  return useQuery({
    queryKey: ['shippingRates'],
    queryFn: () => shippingService.getShippingRates(),
  });
}
